export const InvestorType = {
	Retail: 'Retail',
	Professional: 'Professional',
	Corporate: 'Corporate',
};
